import { useEffect } from "react";
import { SITE } from "../data/site";
import { setPageSeo } from "../utils/seo";

export default function Contact() {
  const PAGE_URL = `${SITE.domain}/contact`;
  const SEO_TITLE = "Contact Din Lee Engineering | Awning & Roofing Singapore";
  const SEO_DESC =
    "Contact Din Lee Engineering in Singapore for awning, roofing, shade systems, zip track, outdoor blinds, metal works and site quotation.";

  useEffect(() => {
    setPageSeo({
      title: SEO_TITLE,
      description: SEO_DESC,
      canonical: PAGE_URL,
    });
  }, [PAGE_URL]);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you provide site survey in Singapore?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes. We provide site measurement and recommend suitable awning/roofing/shade solutions based on your space and budget.",
        },
      },
      {
        "@type": "Question",
        "name": "What services do you offer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "We provide retractable awning, loop awning, rooftop awnings, glass canopy shelters, ACP/polycarbonate/aluminium fluted/zinc roofing, zip track, outdoor roller blinds, ceilings, metal works and renovation support.",
        },
      },
      {
        "@type": "Question",
        "name": "How to get a quotation?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Send your location, required solution type, approximate size, and photos of the area. We will respond quickly with the next steps.",
        },
      },
    ],
  };

  return (
    <>
      {/* FAQ Schema (Helmet ছাড়া) */}
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10">
        <div>
          <h1 className="text-3xl font-extrabold text-slate-900">Contact Us</h1>
          <p className="mt-3 text-slate-600">
            Fast quotation for awning, roofing, shade systems, zip track and outdoor blinds in Singapore.
          </p>

          <div className="mt-6 rounded-2xl border bg-white p-5 space-y-2 text-sm text-slate-700">
            <div>
              <b>Phone:</b>{" "}
              <a className="hover:underline" href={`tel:${SITE.phone.replace(/\s/g, "")}`}>
                {SITE.phone}
              </a>
            </div>

            <div>
              <b>Office:</b> {SITE.addressLine}, {SITE.cityLine}
            </div>

            {SITE.emailPrimary ? (
              <div>
                <b>Email:</b>{" "}
                <a className="hover:underline" href={`mailto:${SITE.emailPrimary}`}>
                  {SITE.emailPrimary}
                </a>
              </div>
            ) : null}

            <div className="pt-2 flex gap-2 flex-wrap">
              <a
                className="inline-block px-4 py-2 rounded-xl bg-green-600 text-white font-semibold hover:opacity-95"
                href={`https://wa.me/${SITE.whatsapp.replace(/\D/g, "")}`}
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp Now
              </a>
              <a
                className="inline-block px-4 py-2 rounded-xl border font-semibold hover:bg-slate-50"
                href={`tel:${SITE.phone.replace(/\s/g, "")}`}
              >
                Call Now
              </a>
            </div>
          </div>

          <form className="mt-6 rounded-2xl border bg-white p-5 space-y-3">
            <div className="grid sm:grid-cols-2 gap-3">
              <input className="border rounded-xl px-4 py-3" placeholder="Name" />
              <input className="border rounded-xl px-4 py-3" placeholder="Phone / WhatsApp" />
            </div>
            <input className="border rounded-xl px-4 py-3 w-full" placeholder="Email" />
            <textarea
              className="border rounded-xl px-4 py-3 w-full min-h-[120px]"
              placeholder="What do you need? (e.g., retractable awning, polycarbonate roof, zip track...)"
            />
            <button
              type="button"
              className="w-full px-5 py-3 rounded-xl bg-blue-600 text-white font-bold hover:opacity-95"
            >
              Send Request
            </button>
            <p className="text-xs text-slate-500">
              Production a form submit EmailJS / WhatsApp redirect / API endpoint connect.
            </p>
          </form>
        </div>

        <div className="rounded-2xl border overflow-hidden bg-slate-50">
          <iframe
            title="Din Lee Engineering Map"
            className="w-full h-[520px]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              SITE.addressLine + ", " + SITE.cityLine
            )}&output=embed`}
          />
        </div>
      </section>
    </>
  );
}
